<template>
  <div class="page form_page js_show">
    <div class="weui-form">
      <div class="weui-form__text-area">
        <h2 class="weui-form__title">连锁总店信息</h2>
        <div class="weui-form__desc">连锁总店信息进行修改与完善</div>
      </div>

      <div class="weui-form__control-area">

        <div class="weui-cells__group weui-cells__group_form">
          <div class="weui-cells weui-cells_form">

            <div class="weui-cell weui-cell_active">
              <div class="weui-cell__hd">
                <label class="weui-label">连锁公司名</label></div>
              <div class="weui-cell__bd">
                <input v-model="formSet.chainName" class="weui-input" prop="salesmanCompany" placeholder="请输入公司">
              </div>
            </div>

            <div class="weui-cell weui-cell_active">
              <div class="weui-cell__hd">
                <label class="weui-label">联系人</label></div>
              <div class="weui-cell__bd">
                <input v-model="formSet.chainPersonName" prop="salesmanName" class="weui-input" placeholder="请输入姓名">
              </div>
            </div>

            <div class="weui-cell weui-cell_active">
              <div class="weui-cell__hd">
                <label class="weui-label">手机号</label></div>
              <div class="weui-cell__bd">
                <input v-model="formSet.chainPersonPhone" class="weui-input" prop="salesmanPhone" placeholder="请输入手机号">
              </div>
            </div>

          </div>
        </div>
      </div>
      <div class="weui-form__opr-area">
        <a class="weui-btn weui-btn_primary" href="javascript:" id="showTooltips" @click="handleSubmit">确定</a>
        <a class="weui-btn weui-btn_warn" href="javascript:" id="showTooltips1" @click="logonOut">退出</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      formSet: {
        id:'',
        chainName: '',
        chainPersonName: '',
        chainPersonPhone: ''
      },
      workerRules: {
        chainName: [
          {required: true, trigger: 'blur', message: '请输入连锁名称!'}
        ],
        chainPersonName: [
          {required: true, message: '请输入联系人名称!', trigger: 'blur'}
        ],
        chainPersonPhone: [
          {required: true, message: '请输入联系人手机号!', trigger: 'blur'}
        ]
      }
    }
  },
  methods: {
    handleSubmit () {
      this.$axios({
        method: 'post',
        url: '/v1/wChain/save',
        data: this.formSet
      }).then((response) => {
        console.log('保存成功', response)
        if (response.data.code === 200) {
          this.$storage.saveStorage("user", this.formSet)
          this.$router.push({path: 'jddeptMan'})
        }
      }).catch((error) => {
        console.log('保存失败', '保存失败')
      })
    },

    logonOut () {
      this.$storage.removeStorage()
      this.$weui.topTips('退出成功,后续操作请重新登录');
      this.$router.push({path: '/jd'})
    },

    chainInfo(){
      this.$axios({
        method: 'get',
        url: '/v1/wChain/info?id='+this.formSet.id
      }).then((response) => {
        if (response.data.code === 200) {
          this.formSet = response.data.data
        }
      }).catch((error) => {
        console.log('保存失败', '保存失败')
      })
    }
  },

  mounted () {
    // 如果当前已登录且为“我是业务员”直接跳转
    let user = this.$storage.fetchStorage("user")
    if (user !== null && user !== '' && user.userFlag === 'chain') {
      this.formSet.id = user.id
      this.chainInfo()
    }
  },
  components: {

  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/jdRegister/jdchainInfo.vue